import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import logo from '../../assets/image/4BoxesHeader.png';

const styles = StyleSheet.create({
  body: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 20,
  },
  headerView: {
    width: '100%',
  },
  headerImage: {
    marginBottom: 10,
    textAlign: 'center',
    width: '25%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  box: {
    backgroundColor: 'white',
    border: '1px solid #00B3B0',
    borderRadius: 6,
    paddingTop: 18,
    paddingBottom: 18,
    width: '100%',
    display: 'flex',
    margin: '10 0',
  },
  boxTitle: {
    fontWeight: 'bold',
    fontSize: 14,
    marginBottom: 18,
    color: 'black',
    textAlign: 'center',
  },
  text: {
    padding: '5 10',
    fontSize: 13,
  },
  nofound: {
    fontSize: 12,
    color: '#BFBFBF',
  },
});

const PdfBoxes = ({ categories, author }) => {
  return (
    <Document title="4 Boxes" author={author}>
      <Page size="A4" style={styles.body}>
        <View fixed style={styles.headerView}>
          <Image style={styles.headerImage} src={logo} />
        </View>
        {categories?.length > 0 ? (
          categories.map(category => {
            return (
              <View key={category.id} style={styles.box}>
                <Text style={styles.boxTitle}>{category.title}</Text>
                <View>
                  {category.goals.length > 0 ? (
                    category.goals.map((goal, i) => (
                      <Text
                        key={goal.id}
                        style={{
                          backgroundColor: i % 2 === 0 ? '#F3F6F9' : 'white',
                          ...styles.text,
                        }}
                      >
                        {goal.text}
                      </Text>
                    ))
                  ) : (
                    <Text style={{ ...styles.text, ...styles.nofound }}>
                      No items found
                    </Text>
                  )}
                </View>
              </View>
            );
          })
        ) : (
          <Text style={{ ...styles.text, ...styles.nofound }}>
            No categories found
          </Text>
        )}
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default PdfBoxes;
